import clsx from 'clsx'
import { formatMoney } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  // Get currency formatting from global state
  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'

  const formatPrice = (value: string) => {
    if (!value) return ''

    // Convert string price to cents (assuming price is in dollars)
    const priceInCents = Math.round(parseFloat(value) * 100)

    // Use the existing formatMoney function with the shop's money format
    return formatMoney(priceInCents, moneyFormat)
  }

  return (
    <p className={clsx(className)}>
      {!isOnSale ? null : (
        <span className="line-through paragraph-b font-bold">
          {formatPrice(compareAtPrice || '')}
        </span>
      )}

      <span className={clsx('paragraph-b font-bold', isOnSale ? 'text-brand-red' : '')}>
        {formatPrice(price)}
      </span>
    </p>
  )
}
